/* eslint max-classes-per-file: 0 */

import {
  DataCollection as Data,
  DataCollectionCollection as Collection,
} from '@/typings/api/DataCollection'
import { DataCollectionsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PublicationDataCollectionsTransformerParams extends TransformerParams {
  protected defaultParams = [
    'publication_id',
  ];
}

export class PublicationDataCollectionsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PublicationDataCollectionsTransformerParams();
}
